import React, { ReactNode } from 'react'
import ReactModal from 'react-modal'
import { AiOutlineClose } from 'react-icons/ai'
import 'styled-components/macro'
import { styled } from 'styled-components'
import { _tempTheme } from '../../utils/tempTheme'
import classNames from 'classnames'

const MODAL_Z_INDEX = 10
ReactModal.defaultStyles = {
	overlay: {
		...ReactModal.defaultStyles.overlay,
		zIndex: MODAL_Z_INDEX,
	},
	content: {
		...ReactModal.defaultStyles.content,
		zIndex: MODAL_Z_INDEX,
		top: '45%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		maxWidth: '80%',
		borderRadius: '4px',
		overflowY: 'auto',
		padding: '0',
		transform: 'translate(-50%, -50%)',
	},
}

export interface CustomModalProps {
	overlayClassName?: any
	isOpen?: boolean
	children: ReactNode
	onClose?: () => void
	lightTheme?: boolean
	closeButton?: boolean
	className?: string
	parentSelector?: HTMLElement
}

export default function CustomModal({
	onClose,
	isOpen = false,
	children,
	closeButton = true,
	className = '',
	parentSelector,
	overlayClassName = '',
}: CustomModalProps): JSX.Element {
	return (
		<ReactModal
			ariaHideApp={false}
			className={classNames(
				'text-brand-space-blue border-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg',
				className
			)}
			overlayClassName={classNames(
				'fixed inset-0 bg-black/70 z-10',
				overlayClassName
			)}
			isOpen={isOpen}
			onRequestClose={onClose}
			parentSelector={parentSelector ? () => parentSelector : undefined}
			css="::-webkit-scrollbar {
					border-radius: 4px;
					width: 8px;
					height: 8px;
				}
			
				::-webkit-scrollbar-track {
					border-radius: 4px;
					background: #f1f1f1;
				}
			
				::-webkit-scrollbar-thumb {
					border-radius: 4px;
					background: #888;
				}
				&:focus-visible {
					outline: none;
				}
			">
			{children}
			{closeButton && (
				<CloseButton onClick={onClose} title="Close Modal">
					<AiOutlineClose />
				</CloseButton>
			)}
		</ReactModal>
	)
}

const CloseButton = styled.button`
	position: absolute;
	cursor: pointer;
	background-color: transparent;
	border: none;
	color: ${({ theme }) => theme.darkGreyColor};
	margin: ${_tempTheme.spacing2};
	font-weight: ${_tempTheme.font_bold};
	font-size: ${_tempTheme.text_lg};
	top: 0;
	right: 0;
	transition: transform 200ms ease-in-out;
	&:hover {
		transform: scale(1.25);
	}
`
